import React from 'react';
import cn from 'classnames';
import DropdownMenuItem from "../../../../ui/DropdownMenuItem";
import IconPaid from "../../../../components/icon/IconPaid";
import IconNotPaid from "../../../../components/icon/IconNotPaid";
import {StatusOfflineIcon, StatusOnlineIcon} from "@heroicons/react/outline";

type Props = {
  limited: boolean
  onChange?: (value: boolean) => void
}

export default function LimitAccessToggle({
  limited, onChange,
}: Props) {

  function toggle(newState: boolean) {
    if (onChange && newState !== limited) {
      return () => onChange(newState)
    }
    return undefined;
  }

  return (
    <>
      <DropdownMenuItem onClick={toggle(true)} caption="Limited" className={cn({ 'font-bold': limited })}>
        <StatusOfflineIcon className={(limited ? 'text-black' : 'text-gray-dark') + "h-4 w-4 inline -ml-1 mr-3"} />
      </DropdownMenuItem>

      <DropdownMenuItem onClick={toggle(false)} caption="Full" className={cn({ 'font-bold': !limited })}>
        <StatusOnlineIcon className={(!limited ? 'text-black' : 'text-gray-dark') + "h-4 w-4 inline -ml-1 mr-3"} />
      </DropdownMenuItem>
    </>
  );
}
